import React from "react";
import { Star, Sparkles } from "lucide-react";

export const RatingBadge = ({ source = {}, className = "", testid = "rating-badge" }) => {
  const rating = Number(source.rating ?? source.avg_rating ?? source.average_rating ?? 0);
  const count = Number(source.reviews_count ?? source.review_count ?? source.total_reviews ?? 0);
  if (rating > 0) {
    return (
      <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full bg-ink text-white text-xs font-semibold px-2.5 py-1 ${className}`}>
        <Star className="w-3 h-3 fill-current" aria-hidden="true" /> {rating.toFixed(1)}
        {count > 0 && <span className="font-normal opacity-80">· {count} review{count !== 1 ? "s" : ""}</span>}
      </span>
    );
  }
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full bg-ink text-white text-xs font-semibold px-2.5 py-1 ${className}`}>
      <Star className="w-3 h-3 fill-current" aria-hidden="true" /> New
    </span>
  );
};

export default RatingBadge;
